
import { Outlet } from "react-router-dom";
import { AdminNavbar } from "../admin/AdminNavbar";

const AdminLayout = () => {
  return (
    <div className="min-h-screen bg-background">
      <AdminNavbar />
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
